import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Loading from '@/components/ui/Loading';
import ScrollProgress from '@/components/ui/ScrollProgress';
import ErrorBoundary from '@/components/ErrorBoundary';

/**
 * MainLayout - Central layout wrapper for consistency and performance.
 * Features:
 * - Suspense boundary for lazy-loaded pages
 * - ErrorBoundary for partial application failures
 * - Dynamic page title management
 * - Responsive layout management
 */
const MainLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Dynamic page title logic
    const path = pathname.split('/').filter(Boolean)[0] || 'Home';
    const capitalized = path.charAt(0).toUpperCase() + path.slice(1);
    document.title = `${capitalized} | NFskills — IT Training Institute`;
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <ScrollProgress />
      <Navbar />
      
      <main id="content" tabIndex={-1} className="flex-grow focus:outline-none">
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;
